import { IconShipping16 } from '@warp-ds/icons/react/shipping-16';
import React from 'react';
import type { BapAd } from '../../../types';
import type { LabelRenderProps } from '../SearchAdPrimaryLabel';
import { SearchAdPrimaryLabel } from '../SearchAdPrimaryLabel';

const sortedLabelIds = ['sold', 'fiks_ferdig'];

type BapLabelProps = {
    ad: BapAd;
    className?: string;
    label?: (props: LabelRenderProps) => React.ReactElement | null;
};

export function BapLabel(props: BapLabelProps) {
    const { ad, className, label } = props;

    return (
        <SearchAdPrimaryLabel
            ad={ad}
            className={className}
            labelIds={sortedLabelIds}
            render={label ?? renderBapLabel}
        />
    );
}

function renderBapLabel({ className = '', classes, label }: LabelRenderProps) {
    if (!label) {
        return null;
    }

    return (
        <>
            {label.id === 'sold' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'fiks_ferdig' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    <IconShipping16 className="mr-4" />
                    {label.text}
                </span>
            )}
        </>
    );
}
